import React from "react"

const SuspenseFallback = ({ className, displayText = "Loading..." }) => (
  <div
    className={
      className
        ? className
        : "flex flex-col items-center justify-center h-full min-h-[300px] gap-4"
    }
  >
    <div className="w-10 h-10 border-4 border-secondary-200 border-t-primary1-600 rounded-full animate-spin" />
    <span className="text-secondary-500 text-sm font-normal">
      {displayText}
    </span>
  </div>
)

export default SuspenseFallback
